export enum UserRole {
  ROOT = 'root',
  USER = 'user',
  ADMIN = 'admin',
  OWNER = 'owner',
  SYSTEM = 'system',
  OPERATOR = 'operator',
  POWER_USER = 'power user',
  DATA_ADMIN = 'data admin',
  GRC_REVIEWER = 'grc reviewer',
  DATA_ANALYST = 'data analyst',
  PLATFORM_ADMIN = 'platform admin',
}
